/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message, Modal } from "antd";
import axios from "axios";
import moment from "moment";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { getRoute } from "../../lib/routes";
import { baseUrl } from "../../lib/routes/baseUrl";
import { buildQueryString, buildQueryStringWithObjectParams } from "../../lib/utils";
import { toHttpFormatStartOfDay } from "../../lib/utils/formatDate";

const initialState = {
  tariffs: [],
  tariffsLoading: rtkRequestStatusCodes.idle,
  allTariffs: [],
  allTariffsLoading: rtkRequestStatusCodes.idle,
};

export const fetchCommonTariffs = createAsyncThunk(
  "tariffs/fetchCommonTariffs",
  async ({ serviceTypeId, onDate = toHttpFormatStartOfDay(moment()), status, type = "common" }) => {
    const queryString = buildQueryStringWithObjectParams(
      { serviceTypeId, onDate, status, type },
      true
    );
    const url = `${baseUrl}/offerings-api/tariffs/search?${queryString}`;
    const response = axios.get(url);
    const { data } = await response;
    return data;
  }
);

export const fetchAllCommonTariffs = createAsyncThunk("tariffs/fetchAllCommonTariffs", async () => {
  const url = `${baseUrl}/offerings-api/tariffs/search?type=common`;
  const response = axios.get(url);
  const { data } = await response;
  return data;
});

export const updateTariff = createAsyncThunk(
  "tariffs/updateTariff",
  async ({ tariff, ...queryParams }) => {
    const queryString = buildQueryString(queryParams);
    const url = [getRoute("offerings-api", "tariffs", `${tariff.id}?`), queryString].join("");
    try {
      message.loading("Обновляем версию тарифа");
      await axios.patch(url, tariff);
      message.destroy();
      message.success("Версия обновлена");
    } catch (e) {
      message.destroy();
      Modal.error({
        content: e.response?.data?.message || "Что-то пошло не так...",
      });
    }
  }
);

export const deleteTariff = createAsyncThunk(
  "tariffs/deleteTariff",
  async ({ tariffId, fromDate }) => {
    const queryString = buildQueryString({ fromDate });
    const url = [getRoute("offerings-api", "tariffs", `${tariffId}?`), queryString].join("");
    try {
      message.loading("Закрытие версии...");
      await axios.delete(url);
      message.success("Версия закрыты");
    } catch (e) {
      message.destroy();
      Modal.error({
        content: e.response?.data?.message || "Что-то пошло не так...",
      });
    }
  }
);

const tariffsSlice = createSlice({
  name: "tariffs",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchCommonTariffs.fulfilled]: (state, { payload }) => {
      const sortedTariffs = payload.sort((a, b) => a.name.localeCompare(b.name, "ru"));
      state.tariffs = sortedTariffs;
      state.tariffsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchCommonTariffs.pending]: (state) => {
      state.tariffsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchCommonTariffs.rejected]: (state) => {
      state.tariffsLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchAllCommonTariffs.fulfilled]: (state, { payload }) => {
      const sortedAllTariffs = payload.sort((a, b) => a.name.localeCompare(b.name, "ru"));
      state.allTariffs = sortedAllTariffs;
      state.allTariffsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchAllCommonTariffs.pending]: (state) => {
      state.allTariffsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchAllCommonTariffs.rejected]: (state) => {
      state.allTariffsLoading = rtkRequestStatusCodes.rejected;
    },
  },
});

const { reducer } = tariffsSlice;

export { reducer };
